import { createClient } from "@connectrpc/connect";
import { createGrpcWebTransport } from "@connectrpc/connect-web";
import {
  CandidateService,
  ChatService,
  DestinationService,
  PaymentService,
  PlaceService,
  ScheduleService,
  SearchService,
  TravelerService,
  TripService,
  UserService,
} from "@generated/proto/service";

import { auth } from "./firebase";

// Get the API base URL from environment
const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || "http://localhost:9000";

/**
 * Create the gRPC-Web transport with Firebase authentication
 */
const transport = createGrpcWebTransport({
  baseUrl: API_BASE_URL,
  interceptors: [
    (next) => async (req) => {
      try {
        const currentUser = auth.currentUser;
        if (currentUser) {
          const token = await currentUser.getIdToken();
          req.header.set("Authorization", `Bearer ${token}`);
        }
      } catch (error) {
        console.warn("Failed to get auth token:", error);
      }
      return await next(req);
    },
  ],
});

export const userClient = createClient(UserService, transport);
export const tripClient = createClient(TripService, transport);
export const chatClient = createClient(ChatService, transport);
export const destinationClient = createClient(DestinationService, transport);
export const scheduleClient = createClient(ScheduleService, transport);
export const searchClient = createClient(SearchService, transport);
export const travelerClient = createClient(TravelerService, transport);
export const paymentClient = createClient(PaymentService, transport);
export const placeClient = createClient(PlaceService, transport);
export const candidateClient = createClient(CandidateService, transport);

export function resetGrpcAuth() {}
